import { Content, Pagination } from "@/@types/general.ts";
import { authAxios } from "@/api/axios.ts";
import { ContentComment, ContentHistory, EpisodeHistory } from "@/api/feed/feed.types.ts";
import { getLimitOffset } from "@/utils/funcs.ts";

class FeedRequests {
  static isLoggedIn() {
    return Boolean(localStorage.getItem("splay:token"));
  }

  static getContentHistory = async (limit: number, offset: number) => {
    const searchParams = getLimitOffset(limit, offset);
    return authAxios
      .get<Pagination<ContentHistory>>("/feed/web/content-history", { params: searchParams })
      .then((res) => res.data);
  };

  static getCommentList = async (limit: number, offset: number, id: number) => {
    const searchParams = getLimitOffset(limit, offset);
    return authAxios
      .get<
        Pagination<ContentComment>
      >((this.isLoggedIn() ? `/feed/comments-rating/` : "/content/no-auth/content-reviews/") + id, { params: searchParams })
      .then((res) => res.data);
  };

  static createComment = async ({ id, rating, text }: { id: number; rating: number; text: string }) => {
    return authAxios
      .post<Pagination<ContentComment>>(`/feed/comments-rating/${id}`, { rating, text })
      .then((res) => res.data);
  };

  static getEpisodeHistory = async (id: number) => {
    return authAxios.get<EpisodeHistory>(`/feed/history/${id}`).then((res) => res.data);
  };

  static postEpisodeHistory = async ({ formData }: { formData: FormData }) => {
    return authAxios.post("/feed/update-history", formData);
  };
  static postSupportMessage = async ({ formData }: { formData: FormData }) => {
    return authAxios.post("/user/support-video-message", formData);
  };

  static createFavoriteContent = async (id: number) => {
    return authAxios.post(`/feed/favorite-content`, { content_id: id });
  };

  static deleteFavoriteContent = async (id: number) => {
    return authAxios.delete(`/feed/favorite-content`, { data: { content_id: id } });
  };

  static createNotRecContent = async (id: number) => {
    return authAxios.post(`/feed/not-recommended-content`, { content_id: id });
  };

  static deleteNotRecContent = async (id: number) => {
    return authAxios.delete(`/feed/not-recommended-content`, { data: { content_id: id } });
  };

  static async getFavorites(limit: number, offset: number) {
    const searchParams = getLimitOffset(limit, offset);

    return authAxios
      .get<Pagination<Content>>("/feed/web/favorite-content", { params: searchParams })
      .then((res) => res.data);
  }
}

export default FeedRequests;
